/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps  */
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ITopWalletsResponseItem } from '@kattana-io/common';
import DesktopTable from '../../../molecules/Table/DesktopTable';
import Text from '../../../atoms/Text';
import StatsShort from '../StatsShort';
import { useTableData } from './useTableData';
import { EWalletsTimeframes, ITopTradersSelector } from '.';
import { actionShowModal } from '../../../actions/modal';
import { ModalTypes } from '../../../reducers/modal';
import { formatPrice } from '../../Modal/WalletModal/formatters';
import { toFixed4 } from '../formatters';
import { getVolume } from '../helpers';

export const LS_TOP_TRADERS_HIDDEN_COLUMNS_KEY =
  'kattana-simple.top_traders_table_columns_hidden';
export const LS_TOP_TRADERS_KEY = 'kattana-simple.top_traders_table_columns';

interface ITopTradersTableProps extends ITopTradersSelector {
  timeframe: EWalletsTimeframes;
  handleSetTimeframe(day: EWalletsTimeframes): void;
  loading: boolean;
  address: string | undefined;
  width?: number;
  wallets: any[];
}

const getClassNameForRow = (row: ITopWalletsResponseItem) => {
  if (row.buy_count > 0 && row.sell_count > 0) {
    return 'row--Both text--grey-600';
  }
  if (row.buy_count > 0) {
    return 'row--Buy text--green-600';
  }
  return 'row--Sell text--red-600';
};

/**
 * Implements a table with trades
 * @param param0
 */
const TopTradersTable = ({
  wallets,
  timeframe,
  handleSetTimeframe,
  loading,
  exchange,
  address,
  base_decimals,
  quote_decimals,
  base,
  quote,
  rates,
  flipped,
  chain,
  width,
}: ITopTradersTableProps) => {
  const dispatch = useDispatch();

  const showModal = (rowData: ITopWalletsResponseItem) =>
    dispatch(
      actionShowModal(ModalTypes.wallet, {
        wallet: rowData?.wallet,
        address,
        exchange,
        timeframe: timeframe.toLocaleLowerCase(),
        chain,
      })
    );

  const { columns, data, tableColumnsWidth } = useTableData({
    wallets,
  });

  const renderCell = (cell: any, index: number) => {
    switch (cell.column.id) {
    case '№':
      return <Text size={12}>{index}</Text>;
    case 'wallet':
      return (
        <Text className='wallet' size={12}>
          {cell.value.slice(0, 6) +
              '...' +
              cell.value.slice(cell.value.length - 4)}
        </Text>
      );
    case 'volumUSD':
      return (
        <Text size={12}>
          {toFixed4(cell.value)}
        </Text>
      );
    case 'avgUsdBuy':
      return <Text size={12}>{formatPrice(cell.value)}</Text>;
    case 'avgUsdSell':
      return <Text size={12}>{formatPrice(cell.value)}</Text>;
    case 'statistics':
      return (
        <StatsShort
          onShowModal={() => {
            showModal(cell.row.original);
          }}
          buyCount={cell.row.original.buy_count}
          sellCount={cell.row.original.sell_count}
        />
      );

    default:
      return <Text size={12}>{cell.value}</Text>;
    }
  };

  // const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setFilterValue(e.target.value);
  // dispatch({type: 'setFilter', columnId: 'wallet', filterValue: e.target.value});
  // };

  const renderTableControls = useCallback(
    () => (
      <>
        <div
          onClick={() => handleSetTimeframe(EWalletsTimeframes.DAY)}
          className={`pill ${
            timeframe == EWalletsTimeframes.DAY ? 'pill--active' : ''
          }`}
        >
          1d
        </div>
        <div
          onClick={() => handleSetTimeframe(EWalletsTimeframes.WEEK)}
          className={`pill ${
            timeframe == EWalletsTimeframes.WEEK ? 'pill--active' : ''
          }`}
        >
          7d
        </div>
        <div
          onClick={() => handleSetTimeframe(EWalletsTimeframes.MONTH)}
          className={`pill ${
            timeframe == EWalletsTimeframes.MONTH ? 'pill--active' : ''
          }`}
        >
          1M
        </div>
      </>
    ),
    [timeframe]
  );

  return (
    <DesktopTable
      hiddenColumnsKey={LS_TOP_TRADERS_HIDDEN_COLUMNS_KEY}
      dataKey={LS_TOP_TRADERS_KEY}
      title='top_traders'
      tableColumnsWidth={tableColumnsWidth}
      tableWidth={width || 0}
      columns={columns}
      data={data}
      loading={loading}
      getClassNameForRow={getClassNameForRow}
      renderCell={renderCell}
      renderTableControls={renderTableControls}
      onRowClick={showModal}
    />
  );
};

export default TopTradersTable;
